import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Form, Button, Accordion } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  faAngleDown,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faClock,
  faHistory,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import axios from "axios";

import Header from "../../compnents/Header";
import constantV1 from "../../utils/constantV1";
import BookingFormModal from "./BookingFormModal";
import "./room.scss";
import { toast } from "react-toastify";

function RoomDashboard() {
  const navigate = useNavigate();
  const { loginResponse } = useSelector((state) => state.AuthReducer);
  const token = loginResponse?.data?.session?.access_token;
  const user = loginResponse?.data || {};
  const isAdmin = loginResponse?.data?.is_admin
    // const isAdmin = false
  useEffect(() => {
    console.log("token", isAdmin);
  }, [token]);

  const roomRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [bookingData, setBookingData] = useState(null);

  // NOTE: you had both `rooms` and `allRooms`. The modal expects `rooms`.
  // We'll populate `rooms` from allRooms fetch so modal works.
  const [rooms, setRooms] = useState([]);
  const [allRooms, setAllRooms] = useState([]);

  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [userBookings, setUserBookings] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [roomAvailability, setRoomAvailability] = useState(null);
  const [roomBookings, setRoomBookings] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false); // kept for compatibility
  const [isSuccess, setIsSuccess] = useState(false);

  const [formData, setFormData] = useState({
    hostName: "",
    department: "",
    contactNumber: "",
    bookedBy: "",
    employeeCode: "",
    priority: "",
    meetingType: "",
    allocationDate: "",
    timeFrom: "",
    timeTo: "",
    vcRequired: "false",
    participants: "",
    bookingSubject: "",
    bookingDescription: "",
    purposeTag: "",
    setupStyle: "",
    file: null,
    roomId: "",
    roomNumber: "",
    peopleCount: "",
  });

  const [errors, setErrors] = useState({});

  // -------- helpers --------
  const pad = (n) => String(n).padStart(2, "0");
  const toHHMM = (date) => `${pad(date.getHours())}:${pad(date.getMinutes())}`;

  const addMinutesStr = (hhmm, minsToAdd) => {
    if (!hhmm) return "";
    const [h, m] = hhmm.split(":").map(Number);
    const d = new Date();
    d.setHours(h, m, 0, 0);
    d.setMinutes(d.getMinutes() + minsToAdd);
    return toHHMM(d);
  };

  // Prefill user info
  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        hostMail: user.email,
        hostName: user.name || "",
        department: user.department || "",
        contactNumber: user.mobile_no || "",
        bookedBy: user.name || "",
        employeeCode: user.employee_code || "",
        allocationDate: new Date().toISOString().split("T")[0],
        timeFrom: "--:--",
        timeTo: "--:--",
      }));
    }
  }, [user]);

  // Fetch user-specific bookings
  const fetchUserBookings = async () => {
    const fetchURL = isAdmin ? `${constantV1.BASE_URL}/room/bookings/all-users` : `${constantV1.BASE_URL}/room/bookings/all?user_id=${user.user_id}`
    try {
      if (!token || !user.user_id) return;
      const res = await fetch(
        fetchURL,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to fetch bookings");
      setUserBookings(data?.data?.bookings || []);
    } catch (err) {
      console.error("Fetch user bookings error:", err.message);
    }
  };

  useEffect(() => {
    fetchUserBookings();
  }, [token, user?.user_id]);

  // Fetch all rooms for dropdown/filter
  useEffect(() => {
    async function fetchAllRooms(token) {
      try {
        const res = await fetch(`${constantV1.BASE_URL}/room/AllRoom`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (!res.ok)
          throw new Error(data.message || "Failed to fetch all rooms");

        // set both allRooms (original) and rooms (used by modal)
        setAllRooms(data?.data?.rooms || []);
        setRooms(data?.data?.rooms || []);
      } catch (err) {
        console.error("All rooms fetch error:", err.message);
      }
    }
    if (token) fetchAllRooms(token);
  }, [token]);

  // Handle room selection from dropdown (header)
  const changeRoom = async (e) => {
    const roomId = Number(e.target.value);
    const room = allRooms.find((r) => r.roomId === roomId);
    setSelectedRoom(room);
    setSelectedRoomId(roomId);

    // Update formData.roomId too for modal prefilling
    setFormData((prev) => ({
      ...prev,
      roomId: room?.roomId || "",
      roomNumber: room?.roomNumber || "",
    }));

    if (roomId && token) {
      try {
        const res = await fetch(
          `${constantV1.BASE_URL}/room/${roomId}/availability?date=${selectedDate}`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        if (!res.ok) throw new Error(data.message || "Failed to fetch room availability");

        // ✅ Instead of clearing, MERGE new room bookings with old ones
        const newBookings =
          data?.data?.bookings?.map((b) => ({
            ...b,
            roomId: data.data.room.roomId,
            roomNumber: data.data.room.roomNumber,
            allocationDate: b.allocationDate?.split("T")[0],
          })) || [];

        setRoomBookings((prev) => {
          const merged = [...prev, ...newBookings];
          return merged.filter(
            (b, index, arr) =>
              index ===
              arr.findIndex(
                (x) =>
                  x.roomId === b.roomId &&
                  x.allocationDate === b.allocationDate &&
                  x.timeFrom === b.timeFrom &&
                  x.timeTo === b.timeTo
              )
          );
        });


        setRoomAvailability(data?.data?.room || null);
      } catch (err) {
        console.error("Room availability fetch error:", err.message);
      }
    }
  };

  // console.log("booking:::", roomBookings);

  // Prefill selected room in form
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      roomId: selectedRoom?.roomId || prev.roomId,
      roomNumber: selectedRoom?.roomNumber || prev.roomNumber,
    }));
  }, [selectedRoom]);

  const [availableSlots, setAvailableSlots] = useState([]);

  // openModal: now opens even if selectedRoom is null. If selectedRoom exists, fetch availability.
  const openModal = async (clickedDate, clickedTime, bookingData = null) => {

    setSelectedSlot(clickedTime);
    setSelectedDate(clickedDate);

    const now = new Date();
    const clickedDay = new Date(clickedDate);

    if (clickedDay.setHours(0, 0, 0, 0) < now.setHours(0, 0, 0, 0)) {
      toast.warn("You cannot book a room for a past date.");
      return;
    }

    // Fetch availability only if header room selected
    if (selectedRoom?.roomId && token) {
      try {
        const res = await fetch(
          `${constantV1.BASE_URL}/room/${selectedRoom.roomId}/availability?date=${clickedDate}`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();
        // console.log("Room availability API (modal):", data);

        const newBookings =
          data?.data?.bookings?.map((b) => ({
            ...b,
            roomId: data.data.room.roomId,
            roomNumber: data.data.room.roomNumber,
            allocationDate: b.allocationDate?.split("T")[0],
          })) || [];

        setRoomBookings(newBookings);
        setRoomAvailability(data?.data?.room || null);

        if (data?.data?.room?.bookingStatus?.availableSlots) {
          setAvailableSlots(data.data.room.bookingStatus.availableSlots);
        }
      } catch (error) {
        console.error("❌ Error fetching room availability:", error);
      }
    }

    // Default time logic (+15 mins)
    let timeFrom = "";
    let timeTo = "";
    const originalNow = new Date();

    const [h, m] = clickedTime.split(":").map(Number);
    const slotDate = new Date(clickedDay);
    slotDate.setHours(h, m);

    const isToday = clickedDay.toDateString() === originalNow.toDateString();

    if (isToday && slotDate < originalNow) {
      const roundedNow = new Date();
      timeFrom = toHHMM(roundedNow);
      timeTo = addMinutesStr(timeFrom, 15);
    } else {
      timeFrom = clickedTime;
      timeTo = addMinutesStr(clickedTime, 15);
    }

    // UPDATE FORM DATA SAFELY (hostName stays)
    if (bookingData && typeof bookingData === "object") {
      setFormData((prev) => ({
        ...prev,
        roomId: bookingData?.roomId ?? prev.roomId,
        roomNumber: bookingData?.roomNumber ?? prev.roomNumber,
        hostName: bookingData?.hostName ?? prev.hostName,
        allocationDate:
          bookingData?.allocationDate?.split?.("T")?.[0] ?? prev.allocationDate,
        timeFrom: bookingData?.timeFrom ?? prev.timeFrom,
        timeTo: bookingData?.timeTo ?? prev.timeTo,
        people: bookingData?.peopleCount ?? prev.peopleCount,
        participants:
          Array.isArray(bookingData?.participants)
            ? bookingData.participants.join(", ")
            : bookingData?.participants ?? prev.participants,
        bookingSubject: bookingData?.bookingSubject ?? prev.bookingSubject,
        bookingDescription:
          bookingData?.bookingDescription ?? prev.bookingDescription,
      }));

      setShowModal(true);
      setIsModalVisible(true);
      return;
    }

    setShowModal(true);
    setIsModalVisible(true);
    return;
  };


  const closeModal = () => {
    setShowModal(false);
    setIsModalVisible(false);
    setIsSuccess(false);
  };

  // Validation for the main form (kept your original validateForm)
  const validateForm = () => {
    const newErrors = {};
    // note: when modal is opened without header room selected, formData.roomId will be filled from modal
    if (!formData.roomId) newErrors.room_id = "Please select a room";
    if (!formData.allocationDate)
      newErrors.allocation_date = "Booking date is required";
    if (!formData.timeFrom) newErrors.time_from = "Start time is required";
    if (!formData.timeTo) newErrors.time_to = "End time is required";
    if (!formData.bookingSubject)
      newErrors.booking_subject = "Booking subject is required";
    if (!formData.contactNumber)
      newErrors.contact_number = "Contact number is required";
    if (!formData.hostName) newErrors.host_name = "Host name is required";
    if (!formData.department) newErrors.department = "Department is required";
    if (!formData.participants)
      newErrors.participants = "At least one participant email is required";

    // capacity check: ensure peopleCount exists and respects capacity and 70% rule
    const people = Number(formData.peopleCount || 0);
    if (people > 0) {
      const room = allRooms.find((r) => r.roomId === Number(formData.roomId));
      if (room) {
        if (people > room.capacity) {
          newErrors.people = `Room max capacity is ${room.capacity}`;
        }
        const minRequired = Math.ceil(room.capacity * 0.7);
        if (people < minRequired) {
          newErrors.people = `At least ${minRequired} people required  ${room.capacity}`;
        }
      }
    } else {
      newErrors.people = "Number of people is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Generic form change handler (keeps your previous semantics)
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  // POST helper used by both handleSubmit and modal submission
  const postBooking = async (payload) => {
    try {
      const res = await fetch(`${constantV1.BASE_URL}/room/bookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      // console.log("Booking payload:", payload);
      console.log("Token:", token);
      const data = await res.json();
      if (!res.ok) throw new Error(data.error.message || "Booking failed");

      // Refresh bookings after new booking
      await fetchAllBookings();

      setIsSuccess(true);
      setSelectedRoom(null);
      setFormData({
        hostName: user.name || "",
        department: user.department || "",
        contactNumber: user.mobile_no || "",
        bookedBy: user.name || "",
        employeeCode: user.employee_code || "",
        allocationDate: new Date().toISOString().split("T")[0],
        timeFrom: "--:--",
        timeTo: "--:--",
        vcRequired: "false",
        participants: "",
        bookingSubject: "",
        bookingDescription: "",
        purposeTag: "",
        setupStyle: "",
        file: null,
        roomId: null,
        roomNumber: "",
        peopleCount: "",
      });

      await fetchUserBookings();
      // close modal after success
      setShowModal(false);
      setIsModalVisible(false);
    } catch (error) {
      console.error("Booking error:", error);
      toast.error(error.message || "Booking failed");
    }
  };

  // Submit booking (original function kept but now delegates to postBooking)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      room_id: Number(formData.roomId),
      allocation_date: formData.allocationDate,
      time_from:
        formData.timeFrom && formData.timeFrom.length === 5
          ? formData.timeFrom + ":00"
          : formData.timeFrom,
      time_to:
        formData.timeTo && formData.timeTo.length === 5
          ? formData.timeTo + ":00"
          : formData.timeTo,
      booking_subject: formData.bookingSubject,
      booking_description: formData.bookingDescription,
      vc_required: formData.vcRequired === "true",
      participants: formData.participants
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean),
      repeat_booking: "none",
      attachments: formData.file ? [formData.file.name] : [],
      setup_style: formData.setupStyle || "Conference",
      contact_number: formData.contactNumber,
      host_name: formData.hostName,
      department: formData.department,
      purpose_tag: formData.purposeTag
        ? formData.purposeTag.split(",").map((p) => p.trim())
        : [],
      people_count: Number(formData.peopleCount || 0),
    };

    await postBooking(payload);
  };

  // This function is passed to modal: receives modal's form object and posts
  const handleBookingSubmit = async (modalFormData) => {
    // merge modalFormData into state (so UI stays in sync)
    setFormData((prev) => ({ ...prev, ...modalFormData }));

    // build same payload as handleSubmit
    const peopleCount = Number(modalFormData.peopleCount || modalFormData.people || 0);

    const payload = {
      room_id: Number(modalFormData.roomId || formData.roomId),
      allocation_date: modalFormData.allocationDate || formData.allocationDate,
      time_from:
        modalFormData.timeFrom && modalFormData.timeFrom.length === 5
          ? modalFormData.timeFrom + ":00"
          : modalFormData.timeFrom,
      time_to:
        modalFormData.timeTo && modalFormData.timeTo.length === 5
          ? modalFormData.timeTo + ":00"
          : modalFormData.timeTo,
      booking_subject: modalFormData.bookingSubject || formData.bookingSubject,
      booking_description:
        modalFormData.bookingDescription || formData.bookingDescription,
      vc_required:
        (modalFormData.vcRequired || formData.vcRequired) === "true",
      participants:
        (modalFormData.participants || formData.participants || "")
          .split(",")
          .map((p) => p.trim())
          .filter(Boolean),
      repeat_booking: "none",
      attachments: modalFormData.file ? [modalFormData.file.name] : [],
      setup_style: modalFormData.setupStyle || formData.setupStyle || "Conference",
      contact_number: modalFormData.contactNumber || formData.contactNumber,
      host_name: modalFormData.hostName || formData.hostName,
      department: modalFormData.department || formData.department,
      purpose_tag: modalFormData.purposeTag
        ? modalFormData.purposeTag.split(",").map((p) => p.trim())
        : [],
      people_count: peopleCount,
    };

    // basic client-side checks for capacity (enforce not exceeding max and 70% rule)
    const room = allRooms.find((r) => r.roomId === Number(payload.room_id));
    if (!room) {
      toast.error("Please select a valid room.");
      return;
    }

    const maxCap = room.capacity;
    if (peopleCount > maxCap) {
      toast.error(`Room max capacity is ${maxCap}. Reduce number of people.`);
      return;
    }

    const minRequired = Math.ceil(maxCap * 0.7);
    if (peopleCount < minRequired) {
      toast.error(
        `At least ${minRequired} people required (70% of room capacity ${maxCap}).`
      );
      return;
    }

    // time limit check
    const parseHHMM = (t) => {
      if (!t) return null;
      const [hh, mm] = t.split(":").map(Number);
      return hh * 60 + mm;
    };
    const fromMinutes = parseHHMM(payload.time_from?.slice?.(0, 5) || payload.time_from);
    const toMinutes = parseHHMM(payload.time_to?.slice?.(0, 5) || payload.time_to);
    if (fromMinutes == null || toMinutes == null || toMinutes <= fromMinutes) {
      toast.error("Invalid time range selected.");
      return;
    }
    const diff = toMinutes - fromMinutes;
    if (diff > (room.timeLimitMinutes || 15)) {
      toast.error(
        `Selected room allows maximum ${room.timeLimitMinutes} minutes. Please shorten your booking.`
      );
      return;
    }

    await postBooking(payload);
  };

  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [selectedMonth, setSelectedMonth] = useState(today.getMonth() + 1);

  const months = [
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
  ];

  const days = Array.from({ length: 7 }).map((_, i) => {
    const d = new Date(startDate);
    d.setDate(startDate.getDate() + i);
    return d;
  });

  const times = [];
  for (let h = 10; h <= 19; h++) {
    for (let m = 0; m < 60; m += 15) {
      // Stop at exactly 19:00, not beyond
      if (h === 19 && m > 0) break;
      times.push(`${h}:${m.toString().padStart(2, "0")}`);
    }
  }

  const prevWeek = () => {
    const d = new Date(startDate);
    d.setDate(d.getDate() - 7);
    setStartDate(d);
  };
  const nextWeek = () => {
    const d = new Date(startDate);
    d.setDate(d.getDate() + 7);
    setStartDate(d);
  };
  const handleTodayClick = () => {
    const d = new Date();
    setStartDate(d);
    setSelectedMonth(d.getMonth() + 1);
  };
  const handleDateChange = (e) => {
    const d = new Date(e.target.value);
    if (!isNaN(d)) {
      setStartDate(d);
      setSelectedMonth(d.getMonth() + 1);
      setSelectedDate(e.target.value); // update selectedDate for API call
    }
  };
  const handleMonthChange = (e) => {
    const month = parseInt(e.target.value);
    const d = new Date(startDate);
    d.setMonth(month - 1);
    d.setDate(1);
    setStartDate(d);
    setSelectedMonth(month);
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    const date = new Date(timeString);
    if (isNaN(date)) return timeString;
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Asia/Kolkata",
    });
  };

  const getCalendarDateRange = () => {
    const from = new Date(); // current date
    const to = new Date(startDate);
    to.setDate(startDate.getDate() + 6); // last day in 7-day calendar

    const formatDate = (d) => d.toISOString().split("T")[0];
    return { date_from: formatDate(from), date_to: formatDate(to) };
  };

  const userId = localStorage.getItem("user_id");
  // console.log("user:::", userId);

  // Fetch all bookings (all users) to mark red slots
  const fetchAllBookings = async () => {
    try {
      if (!token) return;
      const res = await fetch(
        `https://dotconnect.dotandkey.com/api/v1/room/bookings/all?user_id=${userId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (data.success) {
        const bookings =
          data?.data?.bookings?.map((b) => ({
            ...b,
            timeFrom: b.timeFrom ? new Date(b.timeFrom).toTimeString().slice(0, 5) : "",
            timeTo: b.timeTo ? new Date(b.timeTo).toTimeString().slice(0, 5) : "",
            allocationDate: b.allocationDate ? b.allocationDate.split("T")[0] : "",
          })) || [];

        setRoomBookings(bookings);
      }
    } catch (err) {
      console.error("Failed to fetch all bookings:", err);
    }
  };

  useEffect(() => {
    fetchAllBookings();
  }, [token]);

  const [openIndex, setOpenIndex] = useState(null);
  const toggleCard = (index) => {
    // If same card clicked again, close it
    setOpenIndex(openIndex === index ? null : index);
  };


  return (
    <>
      <Header />
      <Container fluid>
        <Row>
          <Col md={!isAdmin ? 8 : 12} className="ps-0">
            <div className="cal-top-nav">
              <button onClick={handleTodayClick}>Today</button>

              <div className="room-drop">
                <select
                  ref={roomRef}
                  onChange={changeRoom}
                  value={selectedRoom?.roomId || ""}
                  disabled={!selectedDate}
                >
                  <option value="">Select Room</option>
                  {allRooms?.map((room) => (
                    <option key={room.roomId} value={room.roomId}>
                      {room.roomNumber}
                    </option>
                  ))}
                </select>
              </div>

              <div className="top-nav-bottom d-none d-sm-block">
                <button onClick={prevWeek}>&lt;</button>
                <span style={{ margin: "0 5px" }}>
                  {startDate.toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "short",
                  })}
                </span>
                <button onClick={nextWeek}>&gt;</button>
              </div>

              <div className="month-name d-none d-sm-block">
                {months.find((m) => m.id === selectedMonth)?.month},{" "}
                {startDate.getFullYear()}
              </div>

              <input
                type="date"
                value={startDate.toISOString().split("T")[0]}
                onChange={handleDateChange}
              />
            </div>

            {/* Weekly Calendar */}
            <div className="weekly-calendar">
              <div className="header-cell slider-cell"></div>
              {days.map((day, idx) => (
                <div key={idx} className="header-cell">
                  {day.toLocaleDateString("en-US", {
                    weekday: "short",
                    day: "numeric",
                    month: "short",
                  })}
                </div>
              ))}

              {times.map((time, rowIdx) => (
                <React.Fragment key={rowIdx}>
                  {/* Time label (left column) */}
                  <div className="time-cell">{time}</div>
                  {/* Loop through each day column */}
                  {days.map((day, colIdx) => {
                    // Parse current slot time
                    const [hour, minute] = time.split(":").map(Number);
                    const slotDateTime = new Date(day);
                    slotDateTime.setHours(hour, minute, 0, 0);

                    // Determine if this slot has already passed today
                    const now = new Date();
                    const isSameDay = slotDateTime.toDateString() === now.toDateString();
                    const isPast = isSameDay && slotDateTime < now;

                    // Convert time to minutes for comparison
                    const slotStart = hour * 60 + minute;
                    const slotEnd = slotStart + 15;

                    // Filter bookings that overlap with this slot
                    const slotBookings = roomBookings.filter((b) => {
                      if (b.allocationDate !== day.toISOString().split("T")[0]) return false;

                      const [startHour, startMinute] = b.timeFrom.split(":").map(Number);
                      const [endHour, endMinute] = b.timeTo.split(":").map(Number);

                      const bookingStart = startHour * 60 + startMinute;
                      const bookingEnd = endHour * 60 + endMinute;

                      // Overlaps if any part of slot is within booking time range
                      return slotStart < bookingEnd && slotEnd > bookingStart;
                    });

                    // Extract all booked room numbers
                    const roomNumbers = slotBookings.map((b) => b.roomNumber).filter(Boolean);

                    const isBooked = roomNumbers.length > 0;

                    // Define background color
                    const backgroundColor = isBooked
                      ? "#f67700" // Orange for booked
                      : isPast
                        ? "#eee" // Grey for past slots
                        : "#fff"; // White for available

                    return (
                      <div
                        key={colIdx}
                        className="slot-cell"
                        style={{
                          backgroundColor,
                          cursor: isAdmin
                            ? isPast
                              ? "not-allowed"
                              : "pointer"
                            : isPast || isBooked
                              ? "not-allowed"
                              : "pointer",

                        }}
                        onClick={() => {
                          const dateStr = day.toISOString().split("T")[0];

                          // ✅ If admin clicks a booked slot → open modal in view mode
                          if (isAdmin && isBooked) {
                            if (slotBookings.length === 1) {
                              setBookingData(slotBookings[0]);
                              openModal(dateStr, time, slotBookings[0]);
                            } else {
                              setBookingData(slotBookings);
                              openModal(dateStr, time, slotBookings);
                            }

                            return;
                          }


                          // ✅ If normal user (or admin) clicks an available slot → open booking form
                          if (!isPast && !isBooked) {
                            console.log("🟢 Opening booking modal:", {
                              date: dateStr,
                              time,
                              selectedRoom,
                            });

                            setSelectedSlot(time);
                            setSelectedDate(dateStr);
                            setBookingData(null); // reset any previous booking data
                            openModal(dateStr, time);
                          }
                        }}




                      >
                        {/* Display booked room numbers */}
                        {isBooked && (
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 12,
                              textAlign: "center",
                              display: "block",
                              lineHeight: 2,
                            }}
                          >
                            {roomNumbers.join(", ")}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>

            {/* Upcoming Meetings */}
          </Col>
          {
            !isAdmin && <Col md={4}>
              <div className="meeting-list">
                <div className="meet-histroy">
                  <div className="his-head">
                    <h5>History</h5>
                    <FontAwesomeIcon icon={faHistory} />
                  </div>
                  <div className="his-body">
                    {userBookings.filter(
                      (room) => new Date(room.allocationDate) <= new Date()
                    ).length === 0 ? (
                      <h6 className="text-center">No History</h6>
                    ) : (
                      userBookings
                        .filter((room) => new Date(room.allocationDate) <= new Date())
                        .map((room, idx) => (
                          <React.Fragment key={idx}>
                            <div className="each-meet-card">
                              <div className="date">
                                {new Date(room.allocationDate).getDate()}
                                <sub>
                                  {new Date(room.allocationDate).toLocaleDateString(
                                    "en-US",
                                    { weekday: "short" }
                                  )}
                                </sub>

                                <span className="card-month">
                                  <FontAwesomeIcon
                                    icon={faCalendarAlt}
                                    style={{ marginRight: 5 }}
                                  />
                                  {new Date(room.allocationDate).toLocaleDateString("en-US", {
                                    month: "short",
                                  })}
                                </span>
                              </div>
                              <div className="meet-dtls">
                                <div className="meet-title">{room.bookingSubject}</div>

                                <div className="his-time">
                                  <span>
                                    <span>
                                      <FontAwesomeIcon
                                        icon={faClock}
                                        style={{ marginRight: 2 }}
                                      />
                                      <span className="frm">From:</span>
                                    </span>
                                    {formatTime(room.timeFrom)}
                                  </span>
                                  <span>
                                    <span>
                                      <FontAwesomeIcon
                                        icon={faClock}
                                        style={{ marginRight: 2 }}
                                      />
                                      <span className="frm">To:</span>
                                    </span>
                                    {formatTime(room.timeTo)}
                                  </span>
                                </div>
                              </div>
                              <div className="his-room-num">{room.roomNumber}</div>
                            </div>
                          </React.Fragment>
                        ))
                    )}
                  </div>
                </div>
                <div className="meet-wrap">
                  <h4>Upcoming Meetings</h4>
                  {userBookings.filter((room) => new Date(room.allocationDate) >= new Date())
                    .length === 0 ? (
                    <p>No upcoming meetings</p>
                  ) : (
                    userBookings
                      .filter((room) => new Date(room.allocationDate) >= new Date())
                      .map((room, idx) => (
                        <div
                          key={idx}
                          className={`each-meet-card ${openIndex === idx ? "open" : null}`}
                        >
                          <div className="date">
                            {new Date(room.allocationDate).getDate()}
                            <sub>
                              {new Date(room.allocationDate).toLocaleDateString("en-US", {
                                weekday: "short",
                              })}
                            </sub>

                            <span className="card-month">
                              <FontAwesomeIcon
                                icon={faCalendarAlt}
                                style={{ marginRight: 5 }}
                              />
                              {openIndex === idx
                                ? months.find(
                                  (month) =>
                                    month.id === new Date(room.allocationDate).getMonth() + 1
                                )?.month
                                : new Date(room.allocationDate).toLocaleDateString("en-US", {
                                  month: "short",
                                })}
                            </span>
                          </div>
                          <div className="meet-dtls">
                            <div className="meet-title">{room.bookingSubject}</div>
                            <div className="meet-desc">
                              <div className="meet-desc">
                                {openIndex === idx ? room.bookingDescription : null}
                              </div>
                            </div>
                            <div className="time">
                              <span>
                                <span>
                                  <FontAwesomeIcon
                                    icon={faClock}
                                    style={{ marginRight: 2 }}
                                  />
                                  <span className="frm">From:</span>
                                </span>
                                {formatTime(room.timeFrom)}
                              </span>
                              <span>
                                <span>
                                  <FontAwesomeIcon
                                    icon={faClock}
                                    style={{ marginRight: 2 }}
                                  />
                                  <span className="frm">To:</span>
                                </span>
                                {formatTime(room.timeTo)}
                              </span>
                            </div>
                          </div>
                          <div className="room-num">{room.roomNumber}</div>
                          <button onClick={() => toggleCard(idx)} title="Meeting Details">
                            <FontAwesomeIcon icon={faAngleDown} />
                          </button>
                        </div>
                      ))
                  )}
                </div>
              </div>
            </Col>

          }

        </Row>

      </Container>

      <BookingFormModal
  show={showModal}
  onHide={() => setShowModal(false)}
  onClose={closeModal}
  rooms={rooms}
  selectedRoom={selectedRoom}
  selectedDate={selectedDate}
  selectedSlot={selectedSlot}
  onSubmit={handleBookingSubmit}
  errors={errors}
  hostName={isAdmin ? formData.hostMail : formData.hostName}
  isAdmin={isAdmin}
  bookingData={bookingData}
  token={token} // Pass the token here
/>


    </>
  );
}

export default RoomDashboard;
